
<header class="main-bar admin-header guest" *ngIf="guestView">
  <a href="https://deluxy.it" target="_blank" class="guest">
    <img src="assets/img/deluxy_nuovo_logo_2-157w.webp" alt="Deluxy" class="logo-img left">
  </a>
</header>
<header class="main-bar admin-header" *ngIf="!guestView">
  <a routerLink="/">
    <img src="assets/img/deluxy_nuovo_logo_2-157w.webp" alt="Deluxy" class="logo-img left">
  </a>

  <ng-template [ngIf]="!guestView">

    <div class="notification-float">
      <i class="fas fa-bell" *ngIf="user && isNotificationEnable" style="cursor: pointer;" (click)="removePushSubscription()"></i>
      <i class="fas fa-bell-slash" *ngIf="user && !isNotificationEnable" style="cursor: pointer;" (click)="requestPermission()"></i>
    </div>
    <nav class="header-nav left">
      <ul>
        <li [routerLinkActive]="['active']" *ngIf="groups.includes('admin') || groups.includes('partner') || groups.includes('operation') || (isTeamLeader && groups.includes('expert'))">
          <a routerLink="nuovo-consegne">Consegne</a>
        </li>

        <li [routerLinkActive]="['active']" class="li-dropdown" *ngIf="!groups.includes('partner')">
          <a routerLink="activities">ACTIVITIES</a> 
        </li>

        <li [routerLinkActive]="['active']" *ngIf="(!isTeamLeader && groups.includes('expert'))">
          <a routerLink="nuovo-consegne">Consegne</a>
        </li>
        
        <li [routerLinkActive]="['active']" class="li-dropdown" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('admin') || groups.includes('operation') || groups.includes('teamleader') || ( groups.includes('expert') && loggedInExpert?.isTeamLeader ) ">
          <a routerLink="partner">Partner</a>
          <div class="drop-down-list"> 
            <ul class="drop-down-ul">
              <!-- <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('admin') || groups.includes('operation')">
                <a routerLink="servizi">Servizi Partner</a>
              </li> -->
              <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('admin')">
                <a routerLink="partner/fattura">Fatturazione</a>
              </li> 

              <!--
              <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('admin') || groups.includes('operation') || groups.includes('teamleader') || ( groups.includes('expert') && loggedInExpert?.isTeamLeader )">
                <a routerLink="partner/availability/list">ORARI APERTURA</a>
              </li>
              -->

              <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('admin') || groups.includes('operation') || groups.includes('teamleader') || ( groups.includes('expert') && loggedInExpert?.isTeamLeader )">
                <a routerLink="partners/availability">ORARI APERTURA</a>
              </li>

              <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('admin') || groups.includes('operation')">
                <a routerLink="partner/priority/list">Priorità</a>
              </li>

              <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('admin') || groups.includes('operation')">
                <a routerLink="partner/delivery/rules">Consegne Regole</a>
              </li>

              <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('admin') || groups.includes('operation')">
                <a routerLink="partner/invoices">Invoice List</a>
              </li>

              <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('admin') || groups.includes('operation')">
                <a routerLink="partner/cards">Carte</a>
              </li>

            </ul>
          </div>
        </li>
        <li [routerLinkActive]="['active']" class="li-dropdown" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('admin') || groups.includes('operation') || groups.includes('teamleader') || (groups.includes('expert') && loggedInExpert?.isTeamLeader) ">
          <a routerLink="expert">Valet</a>
          <div class="drop-down-list" *ngIf="groups.includes('admin') || groups.includes('expert') || groups.includes('operation') || groups.includes('teamleader')">
            <ul class="drop-down-ul">
              
              <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('admin')">
                <a routerLink="valet/servizi">Servizi Valet</a>
              </li>

              <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('admin') || groups.includes('operation')">
                <a routerLink="valet/stipendi">Stipendi</a>
              </li>

              <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('admin') || groups.includes('operation')">
                <a routerLink="expert/receipts">RICEVUTE</a>
              </li>

              <!--
              <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('admin') || groups.includes('expert') || groups.includes('operation')">
                <a routerLink="expert/availability/list">ORARI APERTURA</a>
              </li>
              -->

              <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('admin') || groups.includes('expert') || groups.includes('operation')">
                <a routerLink="experts/availability">ORARI APERTURA</a>
              </li>

              <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('admin') || groups.includes('operation')">
                <a routerLink="expert/rules">Regole Valet</a>
              </li>

              <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('admin') || groups.includes('operation')">
                <a routerLink="expert/payments">Pagamenti</a>
              </li>

              <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('admin') || groups.includes('operation')">
                <a routerLink="transzioni">TRANSAZIONI</a>
              </li>

              <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('admin') || groups.includes('operation')">
                <a routerLink="expert/contracts">VALET CONTRATTI</a>
              </li>
             
            </ul>
          </div>
        </li>

        <li [routerLinkActive]="['active']" class="li-dropdown" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('admin')">
          <a routerLink="utenti">Utenti</a>
          <div class="drop-down-list">
            <ul class="drop-down-ul">
              <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}">
                <a routerLink="operation">OPERATION</a>
              </li>
              <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}">
                <a routerLink="customers">Customers</a>
              </li>
            </ul>
          </div>
        </li>

        <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('operation') || groups.includes('partner')">
          <a routerLink="customers">Customers</a>
        </li>

        <li [routerLinkActive]="['active']" class="li-dropdown" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('admin') || groups.includes('operation') || groups.includes('partner')">
          <a routerLink="prodotti">Prodotti</a>
          <div class="drop-down-list" *ngIf="groups.includes('admin') || groups.includes('operation')">
            <ul class="drop-down-ul">
              <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}">
                <a routerLink="product/categoria">Categorie</a>
              </li>
            </ul>
            <ul class="drop-down-ul" *ngIf="groups.includes('admin') || groups.includes('operation')">
              <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}">
                <a routerLink="collections">Prodotto Collections</a>
              </li>

              <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact: true}">
                <a routerLink="cake/orders">Cakes Order Product</a>
              </li>

              <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact: true}">
                <a routerLink="bundle/product">Prodotto in bundle</a>
              </li>

              <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact: true}">
                <a routerLink="product-import">Importazione massiva di prodotti</a>
              </li>
            </ul>
          </div>
        </li>
        <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact: true}"
          *ngIf="groups.includes('partner') && (smsCheck)">
          <a routerLink="smstemplates">Modelli SMS</a>
        </li>

        <li [routerLinkActive]="['active']" class="li-dropdown" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('admin') || groups.includes('operation')">
          <a routerLink="all/vendita">Vendite</a>
          <div class="drop-down-list">
            <ul class="drop-down-ul">

              <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}">
                <a routerLink="vendita">Deluxy Vendite</a>
              </li>

              <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}">
                <a routerLink="cakes/vendita">Cakes Vendite</a>
              </li>

              <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}">
                <a routerLink="business/vendita">Business Vendite</a>
              </li>

              <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}">
                <a routerLink="flowers/vendita">Deluxy Flowers Vendite</a>
              </li>

              <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}">
                <a routerLink="experience/vendita">Deluxy Experience Vendite</a>
              </li>

              <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}">
                <a routerLink="deluxydotcom/vendita">Deluxy.Com Vendite</a>
              </li>
             
            </ul>
          </div>
        </li>

        <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact: true}"
          *ngIf="groups.includes('admin') && user?.isSuperAdmin">
          <a routerLink="finanza">FINANZA</a>
        </li>

        <li [routerLinkActive]="['active']" class="li-dropdown" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('admin') || groups.includes('operation')">
          <a href="javascript:void(0)">Setup</a>
          <div class="drop-down-list">
            <ul class="drop-down-ul">
              <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact: true}">
                <a routerLink="admin/smstemplates">Modelli SMS</a>
              </li>

              <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact: true}">
                <a routerLink="provinces/cities">Provinces</a>
              </li>
              
              <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('admin') || groups.includes('operation')">
                <a routerLink="servizi">Servizi Partner</a>
              </li>

              <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('admin') || groups.includes('operation')">
                <a routerLink="partner-activity-reminder">Promemoria attività partner</a>
              </li>
            </ul>
          </div>
        </li>

        <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('partner')">
          <!-- <a [routerLink]="['/partner', user?.partner?.id, 'availability']">ORARI APERTURA</a> -->
          <a [routerLink]="['/partner', 'availability', user?.partner?.id]">ORARI APERTURA</a>
        </li>

        <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('expert')">
          <!-- <a [routerLink]="['/expert', 'availability', loggedInExpert?.id ]">DISPONIBILITA</a> -->
          <a [routerLink]="['/expert', 'availability', loggedInExpert?.id ]">DISPONIBILITA</a>
        </li>

         <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact: true}"
          *ngIf="groups.includes('partner')">
          <a routerLink="partner/vendita">Vendita</a>
        </li>

        <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('partner')">
          <a routerLink="servizi">Servizi Partner</a>
        </li>

        <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('partner')">
          <a routerLink="partner/invoices" [queryParams]="{ partnerId: loggedInPartner?.id }">Invoice List</a>
        </li>

        <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('partner')">
          <a routerLink="partner/cards">Carte</a>
        </li>

        <li [routerLinkActive]="['active']" class="li-dropdown" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('expert')">
          <a routerLink="valet/stipendi">STIPENDI</a>
          <div class="drop-down-list">
            <ul class="drop-down-ul">

              <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}">
                <a routerLink="expert/receipts">RICEVUTE</a>
              </li>
              
              <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}">
                <a routerLink="transzioni">TRANSAZIONI</a>
              </li>

            </ul>
          </div>
        </li>

        <!-- <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('expert') && !loggedInExpert?.isTeamLeader">
          <a routerLink="expert/payments">Pagamenti</a>
        </li> -->

        <li [routerLinkActive]="['']" [routerLinkActiveOptions]="{exact: true}" *ngIf="groups.includes('partner') && loggedInPartner?.billingAccess">
          <a routerLink="partner/fattura">Fatturazione</a>
        </li>

      </ul>
    </nav>

    <ul class="header-icons right">
      <li id="expertWallet" *ngIf="groups.includes('expert')">
        <i class="fas fa-wallet"></i>
        <span class="wallet">
          <b>{{ (expertWalletAmount || 0) | currency:'EUR' }}</b>
        </span>
      </li>
      <li id="userProfile">
        <span style="margin-right: 7px;">{{user?.name.toUpperCase()}} {{user?.surname.toUpperCase()}}</span>
        <a routerLink="profilo"><img src="assets/img/user.svg" alt="User" class="hvr-grow"></a>
      </li>
      <li>
        <!-- <a routerLink="logout"><i class="fas fa-sign-out-alt"></i></a> -->
        <a (click)="logout()" style="cursor: pointer;" ><i class="fas fa-sign-out-alt"></i></a>
      </li>
      <li *ngIf="user && isNotificationEnable" style="cursor: pointer;" routerLink="/notifications">
        <a><i class="fas fa-bell"></i></a>
        <span class="notification-badge">{{ notificationCount}}</span>
      </li>
      <li *ngIf="user && !isNotificationEnable">
        <a><i class="fas fa-bell-slash"></i></a>
        <span class="notification-badge" style="cursor: pointer; color: white; background: grey;">{{ notificationCount }}</span>
      </li>
    </ul>
    <div id="navIcon" class="menu-btn" (click)="navIconClicked()">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </ng-template>
</header>
<div class="install-popup" *ngIf="infoModal">
  <div class="popup-content">
    <button class="close-btn" (click)="closeInstallPopup()">×</button>
    <h2>Attenzione!</h2>
    <p *ngIf="loggedInPartner?.partnerPaymentStatus">Il tuo stato di pagamento attuale è <b>{{ loggedInPartner?.partnerPaymentStatus?.toUpperCase() }}</b></p>
    <p *ngIf="!loggedInPartner?.partnerPaymentStatus">Lo stato del pagamento è in sospeso</p>
    <p>Contatta l'assistenza per risolvere il problema</p>
    <a class="pop-up-btn" [href]="'tel:' +390282952899">
      <i class="material-icons" style="color: #007BFF;">
        phone
      </i>
    </a>
  </div>
</div>

<div class="install-popup" *ngIf="infoModal">
  <div class="popup-content">
    <button class="close-btn" (click)="closeInstallPopup()">×</button>
    <h2>Attenzione!</h2>
    <p *ngIf="loggedInPartner?.partnerPaymentStatus">Il tuo stato di pagamento attuale è <b>{{ loggedInPartner?.partnerPaymentStatus?.toUpperCase() }}</b></p>
    <p *ngIf="!loggedInPartner?.partnerPaymentStatus">Lo stato del pagamento è in sospeso</p>
    <p>Contatta l'assistenza per risolvere il problema</p>
    <a class="pop-up-btn" [href]="'tel:' +390282952899">
      <i class="material-icons" style="color: #007BFF;">
        phone
      </i>
    </a>
    <!-- <button class="pop-up-btn">Test</button> -->
  </div>
</div>
